import Settings from './config';

export function getApiEndpoint() {
    return (window.apiEndpoint ?? Settings.ENDPOINT) + '/';
}

export function getIdentityEndpoint() {
    return (window.identityEndpoint ?? Settings.IDENTITYENDPOINT) + '/';
}